import React, { Suspense, lazy } from 'react';
import { ProcurementErrorBoundary } from '@/lib/procurement/errorBoundary';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent } from '@/components/ui/card';

// Lazy load the main component
const SubconsManagement = lazy(() => 
  import('./SubconsManagement').then(module => ({ default: module.SubconsManagement }))
);

const SubconsLoadingSkeleton = () => (
  <div className="container mx-auto p-6 space-y-6">
    {/* Header skeleton */}
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <Skeleton className="h-8 w-48 mb-2" />
        <Skeleton className="h-4 w-64" />
      </div>
      <Skeleton className="h-10 w-32" />
    </div>

    {/* Search skeleton */}
    <Card>
      <CardContent className="pt-6">
        <Skeleton className="h-10 w-full" />
      </CardContent>
    </Card>

    {/* Stats skeleton */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {[...Array(3)].map((_, i) => (
        <Card key={i}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <Skeleton className="h-9 w-9 rounded-lg" />
              <div>
                <Skeleton className="h-4 w-24 mb-1" />
                <Skeleton className="h-8 w-12" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>

    {/* Table skeleton */}
    <Card>
      <CardContent className="p-0">
        <Skeleton className="h-[400px] w-full" />
      </CardContent>
    </Card>
  </div>
);

export const OptimizedSubconsManagement: React.FC = () => {
  return (
    <ProcurementErrorBoundary
      fallbackMessage="Có lỗi xảy ra với module Subcontractors. Vui lòng thử lại."
    >
      <Suspense fallback={<SubconsLoadingSkeleton />}>
        <SubconsManagement />
      </Suspense>
    </ProcurementErrorBoundary>
  );
};

export default OptimizedSubconsManagement;